import { z } from 'zod';
import {
  nachversandKindZodEnum,
  retrievalModeZodEnum,
  retrievalStatusZodEnum,
} from '../../enum';

export const retrievalResDto = z.object({
  id: z.number(),
  nachversandKind: nachversandKindZodEnum(),
  retrievalMode: retrievalModeZodEnum(),
  status: retrievalStatusZodEnum(),
  // the booked video call, only set for MAIL retrievals (null = no booking / pickup / voucher)
  Appointment: z
    .object({
      id: z.string(),
      startTime: z.coerce.date(),
      endTime: z.coerce.date(),
    })
    .nullable(),
  dispatchedAt: z.coerce.date().nullable(),
  returnedAt: z.coerce.date().nullable(),
  pickedUpAt: z.coerce.date().nullable(),
  // staff who last acted on the row; on a NONE/NO_FULFILLMENT BDM1 row this can only be the
  // sample-to-voucher switch
  actorUserId: z.string().nullable(),
  // order/creation date, used FE-side as the Teil-2 "Datum" and "bereit seit" column
  createdAt: z.coerce.date(),
  // Prisma @updatedAt, always set, cannot be null. With actorUserId set on a NONE row, this is
  // the switch date
  updatedAt: z.coerce.date(),
});
export type RetrievalResDto = z.infer<typeof retrievalResDto>;

export const retrievalsResDto = z.array(retrievalResDto);
export type RetrievalsResDto = z.infer<typeof retrievalsResDto>;
